/* NewEden2.0 — predictive-search.js
   Predictive search: debounced query to routes.predictive_search_url,
   renders product/collection/page suggestions, keyboard navigation. */
(function () {
  'use strict';
  var NE = window.NewEden || {};
  var url = (NE.routes && NE.routes.predictive_search_url) || '/search/suggest';

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="search"], input[name="q"]');
        this.results = this.querySelector('[data-predictive-results]');
        this.status = this.querySelector('[data-predictive-status]');
        this.cache = {};
        if (!this.input || !this.results) return;
        this.onInput = NE.debounce(this.search.bind(this), 250);
        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('focus', this.onInput);
        this.addEventListener('keydown', this.onKeydown.bind(this));
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });
      }

      search() {
        var q = this.input.value.trim();
        if (q.length < 2) { this.close(); return; }
        if (this.cache[q]) { this.render(this.cache[q], q); return; }
        this.setLoading(true);
        var params = new URLSearchParams({
          q: q,
          'resources[type]': 'product,collection,page,article',
          'resources[limit]': 6,
          'resources[options][unavailable_products]': 'last',
          section_id: 'predictive-search'
        });
        fetch(url + '?' + params.toString(), { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((data) => { this.cache[q] = data; this.render(data, q); })
          .catch(() => this.setLoading(false));
      }

      render(data, q) {
        this.setLoading(false);
        var r = (data && data.resources && data.resources.results) || {};
        var html = '';
        if (r.products && r.products.length) {
          html += '<div class="ps__group"><p class="ps__heading">' + (this.dataset.productsLabel || 'Products') + '</p><ul class="ps__list">';
          r.products.forEach(function (p) {
            var img = p.featured_image ? p.featured_image.url : (p.image || '');
            html += '<li class="ps__item"><a href="' + p.url + '" class="ps__link">' +
              (img ? '<img src="' + img + '&width=80" alt="" width="48" height="60" loading="lazy">' : '') +
              '<span class="ps__info"><span class="ps__title">' + p.title + '</span>' +
              (p.price ? '<span class="ps__price">' + NE.formatMoney(p.price) + '</span>' : '') +
              '</span></a></li>';
          });
          html += '</ul></div>';
        }
        ['collections', 'pages', 'articles'].forEach((key) => {
          if (r[key] && r[key].length) {
            var label = { collections: 'Kollektionen', pages: 'Seiten', articles: 'Magazin' }[key];
            html += '<div class="ps__group"><p class="ps__heading">' + label + '</p><ul class="ps__list ps__list--text">';
            r[key].forEach(function (item) {
              html += '<li class="ps__item"><a href="' + item.url + '" class="ps__link ps__link--text">' + item.title + '</a></li>';
            });
            html += '</ul></div>';
          }
        });
        if (!html) {
          html = '<p class="ps__empty">' + (this.dataset.emptyLabel || 'No results for') + ' "' + q + '"</p>';
        } else {
          html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="ps__all">' +
            (this.dataset.allLabel || 'Alle Ergebnisse anzeigen') + '</a>';
        }
        this.results.innerHTML = html;
        this.open();
      }

      onKeydown(e) {
        var items = Array.prototype.slice.call(this.results.querySelectorAll('a'));
        if (!items.length) return;
        var idx = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[idx - 1] || items[items.length - 1]).focus(); }
        else if (e.key === 'Escape') { this.close(); this.input.focus(); }
      }

      setLoading(on) {
        this.classList.toggle('is-loading', on);
        if (this.status) this.status.textContent = on ? (this.dataset.loadingLabel || 'Suche…') : '';
      }

      open() { this.classList.add('is-open'); this.setAttribute('aria-expanded', 'true'); }
      close() { this.classList.remove('is-open'); this.setAttribute('aria-expanded', 'false'); }
    });
  }
})();
